import { Navigate, useNavigate } from "react-router-dom";
import { AuthService } from "../service/AuthService";
import logo from "../../assets/images/logo.svg"
import { useState } from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

const Header= ()=>{

    const navigate= useNavigate()
    const [dropdownOpen, setDropdownOpen]= useState(false);

    function logout(){
        try {
            AuthService.logout();
            navigate('/')
            
        } catch (error) {
        }
    }

    return(
        <div className="flex max-sm:gap-20 sm:justify-between sm:items-center sm:left-0 sm:z-50 bg-white py-3 h-[100px] sm:fixed top-0 max-sm:w-[100%] sm:w-full w-screen overflow-hidden shadow-md shadow-gray-600">

            {/* huntsjob logo */}
            <div style={{cursor:"pointer"}}>
                <img onClick={()=>navigate('/eventlist')} className="w-44 h-12 sm:ml-5 ml-2" src={logo} alt="huntsjob's logo"/>
            </div>

            {/* login logout button */}
<div className="sm:absolute max-sm:w-48 max-sm:h-20 right-0 top-2 ">
        {
            AuthService.isAuthenticatedUser() && 
                <>
<div className="flex flex-col gap-1 z-50  bg-white">
    <button className="border-none rounded-xl sm:px-3 max-sm:w-36 py-2 sm:mr-8 bg-orange-500 hover:bg-orange-600 text-white font-bold" onClick={()=>setDropdownOpen(!dropdownOpen)}><PersonIcon className="sm:mr-1"/>{AuthService.getCurrentUser().userName.slice(0,1).toUpperCase()+AuthService.getCurrentUser().userName.slice(1)} {!dropdownOpen?<ArrowDropDownIcon/>:<ArrowDropUpIcon/>}</button>
    { 
    <button onClick={()=>logout()} className={"border-none rounded-xl sm:px-3 py-2 sm:mr-8 max-sm:w-36 bg-orange-400 hover:bg-orange-600 text-white font-bold "+ (!dropdownOpen&&"hidden")}>Log out <LogoutIcon/></button>
}
</div>
                    </>
                }
            </div>

        </div>
     )
    }

    export default Header;